import React from 'react';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';

function map(item)
{
    return {...item, id: item.templateID}
}

async function getData()
{
    let indexed = {};

    let response = await api.procedures.templates.getAll();
    let data = await response.json();
    data = data.map((item)=>map(item));
    data.forEach(item => {
        indexed[item.templateID] = item
    });
    
    return {array: data, indexed: indexed};
}

const TemplatesCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {}
    }, 
    funcs: {
        create: () => {},
        update: () => {},
        delete: () => {},
    }
});

function TemplatesCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: []});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalUpdate = React.useCallback((templateID, procedureData) => {
        let tmp = {...data};
        Object.keys(procedureData).forEach((key) => {
            tmp.indexed[templateID][key] = procedureData[key];
        })
        setData(tmp);
    }, [data]);

    const internalAdd = React.useCallback(async (templateID, item) => {
        if(data.indexed[templateID] !== undefined) return internalUpdate(templateID, item);
        let tmp = {...data};
        
        item = map(item);
        let index = tmp.array.push(item);
        tmp.indexed[item.id] = tmp.array[index-1];
        setData(tmp);
        
    }, [data, internalUpdate]);

    const internalDelete = React.useCallback((templateID) => {
        let tmp = {...data};
        let item = tmp.indexed[templateID];

        // remove from array
        let index = tmp.array.indexOf(item);
        if(index > -1) tmp.array.splice(index,1);
        delete tmp.indexed[templateID];

        setData(tmp);

    }, [data]);


    const create = React.useCallback(async (data) => {
        let result = await api.procedures.templates.post(data);
        if(result.ok)
        {
            let item = await result.json();
            internalAdd(item.templateID, item);
            return item;
        }
        else return null;
    }, [internalAdd]);

    const update = React.useCallback(async (templateID, data) => {
        let result = await api.procedures.templates.updateSingle(templateID, data);
        if(result.ok) internalUpdate(templateID, data);

    }, [internalUpdate]);

    const remove = React.useCallback(async (templateID) => {
        let result = await api.procedures.templates.deleteSingle(templateID);
        if(result.ok) internalDelete(templateID);
    }, [internalDelete]);

    React.useEffect( function handleNotifications() {

        const handleCreate = (message) => internalAdd(message.templateID, message);
        // const handleEnable = (message) => internalUpdate(message.templateID, {disabled: false});
        // const handleDisable = (message) => internalUpdate(message.templateID, {disabled: true});
        const handleUpdate = (message) => internalUpdate(message.templateID, message);
        const handleDelete = (message) => internalDelete(message.templateID, message);

        Singletons.NotificationsSocket.on('procedures.templates.created', handleCreate);
        // Singletons.NotificationsSocket.on('procedures.templates.disabled', handleDisable);
        // Singletons.NotificationsSocket.on('procedures.templates.enabled', handleEnable);
        Singletons.NotificationsSocket.on('procedures.templates.updated', handleUpdate);
        Singletons.NotificationsSocket.on('procedures.templates.deleted', handleDelete);

        return () => {
            Singletons.NotificationsSocket.off('procedures.templates.created', handleCreate);
            // Singletons.NotificationsSocket.off('procedures.templates.disabled', handleDisable);
            // Singletons.NotificationsSocket.off('procedures.templates.enabled', handleEnable);
            Singletons.NotificationsSocket.off('procedures.templates.updated', handleUpdate);
            Singletons.NotificationsSocket.off('procedures.templates.deleted', handleDelete);
        }

    }, [internalAdd, internalUpdate, internalDelete]);

    return <TemplatesCtx.Provider value={{loading: loading, data: {...data}, funcs: {create: create, update: update, delete: remove}}} >
        {props.children}
        </TemplatesCtx.Provider>
}

export {TemplatesCtx, TemplatesCtxProvider};